import { Struct } from 'shoteyes-types';
import { Block } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { service } from '../service';
import { SelectStyleEnum } from '../types';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBoxComponent(props: RadioBoxProps): ReactElement {
  const options: RadioBoxProps['option'][] = service.splitArray(props.option ?? [], 2);

  // 考试单独特殊显示
  if (props?.formType === Struct.FormType.ANSWER) {
    return (
      <div className={styles.mb10}> {
        (props?.option ?? [])?.map((row, index) => (
          <Base.Row key={index}>
            <Base.Col span={12} key={`${row.value}_${row.title}`}>
              <div>{row.value}.{row.title}</div>
            </Base.Col>
          </Base.Row>
        ))}
      </div>
    );
  }
  return (
    <Base.Radio.Group
      value={props.value}
      className={styles.radioGroup}
      onChange={event => props.onPropsChange?.({ value: event.target.value })}
    >
      <Block if={props.selectStyle === SelectStyleEnum.GRID}>
        {options.map((row, index) => (
          <Base.Row key={index}>
            {row.map(col => (
              <Base.Col span={12} key={`${col.value}_${col.title}`}>
                <Base.Radio value={col.value}>
                  {col.title}
                </Base.Radio>
              </Base.Col>
            ))}
          </Base.Row>
        ))}
      </Block>
      <Block
        if={[SelectStyleEnum.LINE, SelectStyleEnum.LIST].includes(props.selectStyle)}
      >
        <Base.Space
          direction={
            props.selectStyle === SelectStyleEnum.LIST
              ? 'vertical'
              : 'horizontal'
          }
          wrap
        >
          {(props.option ?? []).map(item => (
            <Base.Radio
              value={item.value}
              key={`${item.title}_${item.value}`}
            >
              {item.title}
            </Base.Radio>
          ))}
        </Base.Space>
      </Block>
      <Block if={props.selectStyle == null}>
        <Base.Space direction="horizontal" wrap>
          {(props.option ?? []).map(item => (
            <Base.Radio
              value={item.value}
              key={`${item.title}_${item.value}`}
            >
              {item.title}
            </Base.Radio>
          ))}
        </Base.Space>
      </Block>
    </Base.Radio.Group>
  );
}
